import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Car } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ClientCompleteProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [cpf, setCpf] = useState('');
  const user = location.state?.user;

  useEffect(() => {
    if (!user) {
      navigate('/client/login');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(
        `${API}/api/auth/google/complete-profile`,
        { cpf_cnpj: cpf, user_type: 'client' },
        { withCredentials: true }
      );

      toast.success('Perfil completado! Agora cadastre seu veículo.');
      navigate('/client/onboarding/vehicle');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao completar perfil');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8">
        <div className="flex items-center justify-center mb-6">
          <Car className="w-12 h-12 text-primary" />
        </div>
        <h1 className="text-2xl font-bold text-center mb-2">Complete seu Cadastro</h1>
        <p className="text-center text-muted-foreground mb-6">
          Olá, {user?.name}! Para continuar, precisamos do seu CPF.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="cpf">CPF</Label>
            <Input
              id="cpf"
              placeholder="000.000.000-00"
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
              required
            />
            <p className="text-xs text-muted-foreground mt-1">
              Seu CPF é necessário para identificação na plataforma
            </p>
          </div>

          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Salvando...' : 'Continuar'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
